import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";


const myTurns = async ({ params, token, callbacks }) => {
    const response = await connection({ method: 'GET', url: `${ENTITY_URL.COLABORADOR.TURNOS.MIS_TURNOS}`, extraHeaders: { token: token }, params: params });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}

export default myTurns;